import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Avatar from './Avatar';
import TagSelectInput from './TagSelectInput';
import MentionsInput from './MentionsInput';
import axios from '../lib/axios';
import Checkbox from './Checkbox';

export default class DiscussionCreator extends Component {
  static propTypes = {
    apiUrl: PropTypes.string.isRequired,
    contextName: PropTypes.string.isRequired,
    contextPopulation: PropTypes.number.isRequired,
    ontology: PropTypes.object.isRequired,
    currentUser: PropTypes.object.isRequired,
    currentUserIsStaff: PropTypes.bool.isRequired,
    onBlur: PropTypes.func,
    focus: PropTypes.bool,
    preFilledTitle: PropTypes.string,
    preFilledBody: PropTypes.string,
    apiUserUrl: PropTypes.string,
    apiCompanyUrl: PropTypes.string,
  }

  static defaultProps = {
    focus: false,
    preFilledTitle: '',
    preFilledBody: '',
    apiUserUrl: '',
    apiCompanyUrl: '',
    onBlur: () => {},
  }

  constructor(props) {
    super(props);

    this.state = {
      focus: this.props.focus,
      title: this.props.preFilledTitle,
      body: this.props.preFilledBody,
      tags: [],
      send_email_notification: false,
      disable_comments: false,
      errors: {},
    };

    this.tagsRef = null;
  }

  handleFocus = (e) => {
    e.stopPropagation();
    this.setState({ focus: true });
  }

  handleBlur = (e) => {
    e.stopPropagation();
    this.props.onBlur();
    this.setState({ focus: false });
  }

  handleClose = (e) => {
    e.stopPropagation();
    this.props.onBlur();
    this.setState({ title: '', body: '', tags: [], disable_comments: false, send_email_notification: false, focus: false, errors: {} });
  }

  handleSubmit(e) {
    e.preventDefault();
    axios
      .request({
        url: this.props.apiUrl,
        method: 'post',
        data: {
          discussion: {
            title: this.state.title,
            body: this.state.body,
            trait_tag_ids: this.state.tags.reduce((acc, item) => {
              acc.push(item.id);
              return acc;
            }, []),
            disable_comments: this.state.disable_comments,
          },
          send_email_notification: this.state.send_email_notification,
        },
      })
      .then(() => {
        this.props.onBlur();
        this.setState({ title: '', body: '', tags: [], disable_comments: false, send_email_notification: false, focus: false, errors: {} });
      })
      .catch((error) => {
        this.setState({ errors: error.response.data.errors });
      });
  }

  handleTitleChange = (event) => {
    this.setState({ title: event.target.value });
  }

  handleBodyChange(value) {
    this.setState({ body: value });
  }

  handleTagsChange(value) {
    this.setState({ tags: value });
  }

  handleCheckboxChange(option) {
    this.setState({ [option]: !this.state[option] });
  }

  render() {
    return (
      <div id="discussion-creator">
        <div className={`u-panel u-relative u-z-110 u-p-0 ${this.state.focus ? 'u-shadow-lg' : ''}`}>
          { !this.state.focus &&
            <div className="u-flex u-items-center u-cursor-pointer u-py-3 u-px-4" onClick={this.handleFocus} id="discussion-creator-trigger">
              <Avatar
                src={this.props.currentUser.avatar.url}
                href={this.props.currentUser.url}
                name={this.props.currentUser.full_name}
                type="user"
                className="Card-avatar" />
              <span className="u-text-lg u-font-semibold u-text-old-primary-color-blue">Start a new discussion</span>
            </div>
          }
          { this.state.focus &&
            <div className="u-py-3 u-px-4">
              <div className="u-flex u-justify-between u-items-center u-mb-3">
                <span className="u-text-lg u-font-bold m-0">Start a new discussion in {this.props.contextName}</span>
                <i className="Icon Icon-close u-flex u-items-center u-cursor-pointer" onClick={this.handleClose} />
              </div>
              <form onSubmit={this.handleSubmit.bind(this)} className="form">
                <div>
                  <label htmlFor="discussion-form-title" className="u-text-sm su-uppercase">Title</label>
                  <input type="text" id="discussion-form-title" className="u-rounded" value={this.state.title} onChange={this.handleTitleChange} />
                  { this.state.errors.title !== undefined &&
                    <span className="error">{ this.state.errors.title }</span>
                  }
                </div>
                <div>
                  <label htmlFor="discussion-form-body" className="u-text-sm su-uppercase">Body</label>
                  <MentionsInput apiUserUrl={this.props.apiUserUrl} apiCompanyUrl={this.props.apiCompanyUrl} value={this.state.body} onChange={(value) => this.handleBodyChange(value)} />
                  { this.state.errors.body !== undefined &&
                    <span className="error">{ this.state.errors.body }</span>
                  }
                </div>
                <div>
                  <label htmlFor="discussion-form-tags" className="u-text-sm su-uppercase">Add tags</label>
                  <TagSelectInput ontology={this.props.ontology} defaultValue={this.state.tags} className="Form" placeholder="Start typing to see suggestions" onTagsChange={(value) => this.handleTagsChange(value)} />
                </div>
                {this.props.currentUserIsStaff &&
                  <div className="Form u-flex u-flex-col u-border u-rounded u-mt-2 u-pt-3 u-pb-1 u-px-4" style={{ backgroundColor: '#F7F7F7' }}>
                    <label className="u-flex u-items-center u-mb-2">
                      <i className="Icon-lock u-flex u-mr-2"></i>Available to Staff Only
                    </label>
                    <Checkbox
                      key="send-email-notification"
                      id="send-email-notification"
                      checked={this.state.send_email_notification}
                      onChange={this.handleCheckboxChange.bind(this, 'send_email_notification')}
                    >
                      Send an email notification about this discussion to {this.props.contextPopulation} people
                    </Checkbox>
                    <Checkbox
                      key="disable-comments"
                      id="disable-comments"
                      checked={this.state.disable_comments}
                      onChange={this.handleCheckboxChange.bind(this, 'disable_comments')}
                    >
                      Disable commenting on this discussion
                    </Checkbox>
                  </div>
                }
                <div className="u-flex u-justify-end u-mt-6">
                  <button type="submit" className="Button Button--xsmall Button--primary">Post discussion</button>
                </div>
              </form>
            </div>
          }
        </div>
        { this.state.focus &&
          <div className="u-fixed u-z-100 u-bg-black u-opacity-25 u-inset-0" onClick={this.handleBlur} />
        }
      </div>
    );
  }
}
